import _ from 'lodash';
const omit = obj => _.omitBy(obj, _.isNil);

/* ===============  本地配置存储 =============*/
const lcSetItem = (key, value) => {
    if (!!localStorage && !!localStorage.setItem) {
        localStorage.setItem(key, value);
    }
};

const lcGetItem = (key) => {
    if (!!localStorage && !!localStorage.getItem) {
        return localStorage.getItem(key);
    }
    return '';
};

const lcRmItem = (key) => {
    if (!!localStorage && !!localStorage.removeItem) {
        return localStorage.removeItem(key);
    }
    return '';
};

export const getDataIndexKey = (dataIndex) => {
    if (!dataIndex) return '';
    else if (Array.isArray(dataIndex)) {
        return dataIndex.join('.');
    }
    return dataIndex;
};

const compareDataIndex = (a, b) => {
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) return false;
        for (let i = 0; i < a.length; i++) {
            if (a[i] !== b[i]) return false;
        }
        return true;
    } else {
        return a === b;
    }
};

// 保存本地配置
export const saveColumnsConfig = (configKey, columns) => {
    if (!configKey) return;
    if (!columns || !Array.isArray(columns)) return;
    const oldConfig = readConfig(configKey);
    const { columns: oldColumnsConfig = {} } = oldConfig || {};
    const config = {};
    // 保存列顺序
    config.indexes = (columns || []).map(col => {
        const { dataIndex, key } = col || {};
        if (dataIndex) {
            return { t: 'data', v: dataIndex };
        }
        return { t: 'key', v: key };
    });
    config.columns = {};
    // 保存列标题，可见性，宽度
    for (const column of columns) {
        const { dataIndex, title, visible = true, width, configDisabled = false } = column || {};
        if (!dataIndex || configDisabled) continue; // 不保存不可配置列
        const key = getDataIndexKey(dataIndex);
        const oldProps = oldColumnsConfig[key] || {};
        config.columns[key] = { ...oldProps, ...omit({ title, visible, width }) };
    }
    lcSetItem(configKey, JSON.stringify(config));
};

const readConfig = (configKey) => {
    try {
        const configStr = lcGetItem(configKey) || '';
        if (!configStr) return {};
        const config = JSON.parse(configStr);
        if (!config || typeof config !== 'object') {
            return {};
        }
        return config;
    } catch (e) {
        console.error(e);
    }
    return {};
};

// 读取本地配置
export const readColumnsConfig = (configKey, columns) => {
    if (!configKey) return columns.map(col => ({ ...col, visible: true }));
    const config = readConfig(configKey);
    const { indexes = [], columns: columnsConfig = {} } = config || {};
    if (!Array.isArray(indexes) || indexes.length === 0) {
        return columns.map(col => ({ ...col, visible: true }));
    }
    const result = [];
    for (const index of indexes) {
        const { t, v } = index || {};
        if (!t || !v) continue;
        let column = null;
        if (t === 'data') {
            column = columns.find(col => compareDataIndex(col.dataIndex, v));
        } else if (t === 'key') {
            column = columns.find(col => col.key === v);
        }
        if (!column) continue;
        const { dataIndex, ...more } = column;
        const key = getDataIndexKey(dataIndex) || '';
        if (!key) {
            result.push({ dataIndex, ...more, visible: true });
            continue;
        }
        const columnConfig = columnsConfig[key] || null;
        if (!columnConfig) {
            result.push({ dataIndex, ...more, visible: true });
            continue;
        }
        const { title, visible, width } = columnConfig;
        const customColumn = {
            dataIndex,
            ...more,
            title,
            visible,
        };
        const nWidth = parseInt(width, 10);
        if (Number.isNaN(nWidth)) {
            if (typeof column.width !== 'undefined') {
                customColumn.width = column.width;
            } else {
                customColumn.resizable = false;
            }
        } else {
            customColumn.width = nWidth;
        }
        result.push(customColumn);
    }
    return result;
};

// clearColumnsConfig 清除本地配置
export const clearColumnsConfig = (configKey) => {
    lcRmItem(configKey);
};
